import { render } from "./ServerLog.vue?vue&type=template&id=79ca16f4"
import script from "./ServerLog.vue?vue&type=script&lang=ts"
export * from "./ServerLog.vue?vue&type=script&lang=ts"
script.render = render

export default script